import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOneCustomer, updateCustomer } from 'slice/customerSlice'; // Import your action creator to fetch a single product
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';

const UpdateCustomer = () => {
    const { id } = useParams(); // Get the id parameter from the URL
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, data } = useSelector((state) => state.customer);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobile: '',
        address: ''
    });

    useEffect(() => {
        dispatch(getOneCustomer(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (data && Object.keys(data).length > 0) {
            setFormData({
                name: data.name || '',
                email: data.email || '',
                mobile: data.mobile || '',
                address: data.address || ''
            });
        }
    }, [data]);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // console.log(formData)
            // const formDataToSend = new FormData();
            // for (const key in formData) {
            //     formDataToSend.append(key, formData[key]);
            // }

            dispatch(updateCustomer({id: id, data: formData}))
            toast('Customer updated successfully!');
            navigate('/customer')

        } catch (error) {
            console.error('There was a problem updating the product:', error.message);
        }
    };


    return (
        <>
            <div className='container card my-5'>
                <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className='col-sm-6 mt-2'>
                        <label htmlFor='customerName'>Customer Name</label>
                        <input type='text' id='customerName' name='name' value={formData.name} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-6 mt-2'>
                        <label htmlFor='customerEmail'>Customer Email</label>
                        <input type='email' id='customerEmail' name='email' value={formData.email} className='form-control' disabled />
                    </div>
                    <div className='col-sm-6 mt-2'>
                        <label htmlFor='customerMobile'>Customer Mobile</label>
                        <input type='text' id='customerMobile' name='mobile' value={formData.mobile} className='form-control' disabled />
                    </div>
                    <div className='col-sm-12 mt-2'>
                        <label htmlFor='customerAddress'>Customer Address</label>
                        <input type='text' id='customerAddress' name='address' value={formData.address} className='form-control' onChange={handleChange} />
                    </div>
                </div>
                <div className='mt-3 text-right'>
                    <button className='btn btn-success' disabled={loading}>Update Customer</button>
                </div>
                </form>
            </div>
        </>
    )
}

export default UpdateCustomer;
